module.exports = __webpack_public_path__ + "img/PTT.480e58be.png";